<template>
  <div class="AddRound">
    <header class="modal-header"> 
        <span class="entity-title" v-if="action=='add'">{{ $t('round.addRound') }} </span>
        <span class="entity-title" v-if="action=='edit'">{{ $t('round.editRound') }} ({{$t('tournaments.round')}} {{round.number}})</span>
    </header>
    <div class="content">
      <div class="statusMessage w3-panel errorBox w3-round" v-show="showStatusMessage">{{statusMessage}}</div>
      <div class="details">
        <label>
          {{ $t('round.date') }}
          <input id="roundDateInput" v-model="_roundDate" class="theme-input" type="text" placeholder="datum">
        </label>
        <div class="buttons" v-if="action!='edit'">
          <button :class="{'button-inactive': addingInProgress || !newRoundFieldsFilled, 'button-default': !addingInProgress && newRoundFieldsFilled }" @click="addAndNew">{{ $t('app.actions.addAndNew') }}</button>
        </div>
        <div class="buttons">
          <div v-if="action=='edit'">
            <button class="button-default" @click="edit">{{ $t('app.actions.edit') }}</button>
          </div>
          <div v-if="action=='add'">
            <button :class="{'button-inactive': addingInProgress || !newRoundFieldsFilled, 'button-default': !addingInProgress && newRoundFieldsFilled }" @click="add">{{ $t('app.actions.add') }}</button>
          </div>
          <button class="button-default" @click="cancel">{{ $t('app.actions.cancel') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";
import moment from 'moment';

const apiName = 'api';

export default {
  name: 'AddRound',
  components: {},
  props: {
    tournamentId: String,
    roundId: String,
    action: String
  },
  data: function () {
    return {
      locale: {
        format: "YYYY-MM-DD",
        weekday: ["Z", "M", "D", "W", "D", "V", "Z"],
        todayBtn: "vandaag",
        clearBtn: "verwijderen",
        closeBtn: "sluiten"
      },
      round: {tournamentId: this.$route.params.tournamentId, number: -1},
      firstTime: true,
      dateString: "",
      adding: false,
      afterAddAndNew: false,
      showingStatusMessage: false,
      statusMessage: ""
    }
  },
  emits: [ 'cancel', 'ok' ],
  beforeMount() {
    if (this.action == "edit") {
      this.loadRound();
    }
  },
  computed: {
    addingInProgress() {
      return this.adding;
    },
    newRoundFieldsFilled() {
      console.log('testing date: ' + this.dateString);
      try {
          var momentVariable = moment( this.dateString, 'DD-MM-YYYY');        
          return moment(momentVariable).format('DD-MM-YYYY') == this.dateString;
        }
        catch {
          console.log('false' );
          return false;
        }
    },
    showStatusMessage() {
      return this.showingStatusMessage;
    },
		_roundDate: {
      get(){
        if (this.firstTime && !(this.action == "add") ) {
          return moment(this.round.date).format('DD-MM-YYYY');
        } else {
          return this.dateString;
        }
      },
      set(newVal){
        try {
          this.dateString = newVal;
          var momentVariable = moment(newVal, 'DD-MM-YYYY');        
          this.round.date = moment(momentVariable).format('YYYY-MM-DDT00:00:00');
        }
        catch {
          console.log("Setter exception" )
          // Do nothing. Input is not yet a valid date.
        }
			}
		}
	},  
  watch: {
    _roundDate: {
      deep: true,
      handler: function () {
        this.firstTime = false;
        console.log("Watcher _rounddate")
      }
    }
  },
  methods: {
    dateSelection(value) {
      this.round.date = value;
    },

    add: function () {
      this.adding = true;
      let that = this;
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.round,
        response: false, 
      };
      let path = "/round/";
      RestAPI
        .post(apiName, path, myInit)
        .then(response => {
            that.round = response;
            console.log("Round saved: "+ that.round.roundId);
            this.adding = false;
            that.$emit('ok');
        })
        .catch(error => {
          this.adding = false;
          console.log(error.response);
        });
    },

    addAndNew: function () {
      this.adding = true;
      let that = this;
      this.afterAddAndNew = true;
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.round,
        response: true, 
      };
      let path = "/round/";
      RestAPI
        .post(apiName, path, myInit)
        .then(response => {
            that.round = response.data;

            // Show succes message for like 5 seconds
            that.statusMessage = "Added round: " + that.round.number + " (" + that.dateString + " )";
            that.showingStatusMessage = true;
            that.adding = false;
            setTimeout(that.hideStatusMessage, 5000);

            // Do not emit, but reset for a new round.
            that.firstTime = true;
            that.round = {tournamentId: this.$route.params.tournamentId, number: -1};
            that.dateString = "";
            var dateInput = document.getElementById("roundDateInput");
            dateInput.value = "";
            console.log("Date reset. ");
            this.adding = false;
          })
        .catch(error => {
          console.log(error.response);
          this.adding = false;
        });
    },

    cancel: function() {
      if (this.afterAddAndNew)
        this.$emit('ok');
      else
        this.$emit('cancel');
    },

    edit: function () {
      let that = this;
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.round,
        response: false, 
      };
      let path = "/round/" + this.roundId;
      RestAPI
        .put(apiName, path, myInit)
        .then(response => {
            console.log("Round edited: " + response);
            that.$emit('ok');
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    hideStatusMessage() {
      console.log("hiding message again");
      this.showingStatusMessage = false;
    },

    loadRound: function () {
      let that = this;
      const myInit = { 
        response: false, 
      };
      let path = '/round/' + this.roundId;
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
            that.round = response;
            console.log("Round loaded: "+ that.round.roundId);
            that.dateString = moment(this.round.date).format('DD-MM-YYYY');
        })
        .catch(error => {
          console.log(error.response);
        });
    }

  }
}

</script>

<style scoped>


.container {
  width: 100vw;
  display: flex;
  justify-content: center;
}

</style>
